import {gql} from '@apollo/client';

export const ECODE_ACTIVATION = gql`
  mutation customerCodeActivationV2($code: String!) {
    customerCodeActivationV2(code: $code) {
      campaignSlug
      activationStatus
    }
  }
`;
export const GET_RM3_PROMOTION = gql`
  query getRM3Promotions(
    $ids: [String!]
    $skuIds: [String!]
    $makroIds: [String!]
    $storeCodes: [String!]
    $conditionFilter: String
    $lang: String
  ) {
    getRM3Promotions(
      ids: $ids
      storeCodes: $storeCodes
      skuIds: $skuIds
      makroIds: $makroIds
      conditionFilter: $conditionFilter
      lang: $lang
    ) {
      itemId
      promoId
      title
      description
      startDate
      endDate
      type
      subType
      meta {
        promoType
        promoAdviseDesc
        conditionType
        targetType
        targetValue
        list {
          itemIds
          itemTargetType
          itemTargetValue
        }
        rewardType
        rewardValue
        maxPerInvoice
        maxPerCustomer
        isTargeted
      }
    }
  }
`;
